import React from 'react';
import { Field } from 'formik';
import clsx from 'clsx';

const Select = ({ className, disabled, ...props }) => (
  <Field
    component="select"
    className={clsx(
      className,
      `w-full appearance-none block py-1.5 pr-10 px-2 text-gray-800 rounded text-left border-none shadow-input focus:shadow-input-focus`,
      { 'opacity-50': disabled },
    )}
    disabled={disabled}
    {...props}
  />
);

export default Select;
